export default __webpack_public_path__ + "static/media/183.428b36a2.png";